import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AccountModule } from '../account/account.module';
import { PaymentResultsEtisalatComponent } from '../card-operations-core/high-order-components/payment-results-etisalat/payment-results-etisalat.component';
import { HomeComponent } from '../home/home/home.component';

const accountRoute = {
  path: '',
  outlet: 'account',
  loadChildren: () => import('../account/account.module').then(m => {
    m.AccountModule.settings = {
      displayAreaConfig: 'side-menu'
    }
    return AccountModule;
  })
};

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full'},
  {
    path: 'home',
    component: HomeComponent,
    children: [accountRoute]
  },
  {
    path: 'search',
    loadChildren: () =>
      import('../search/search.module').then(m => m.SearchModule)
  },
  {
    path: 'account',
    loadChildren: () => import('../account/account.module').then(m => {
      m.AccountModule.settings = {
        displayAreaConfig: 'main-menu'
      }
      return AccountModule;
    })
  }, 
  {
    path: 'feedback',
    loadChildren: () =>
      import('../feedback/feedback.module').then(m => m.FeedbackModule)
  },
  { path: 'paymentResults', component: PaymentResultsEtisalatComponent},
  { path: '**', redirectTo: 'home', pathMatch: 'full'},
]

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes,   {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class RoutingModule { }
